module.exports = __webpack_public_path__ + "img/selected7-min.6c42af0f.png";